import { render, staticRenderFns } from "./VotesSummary.vue?vue&type=template&id=b0dbec5c"
import script from "./VotesSummary.vue?vue&type=script&lang=js"
export * from "./VotesSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports